import React from "react";
import "./SamplePassport.scss";
import VoterIDFront from "../../../assets/docSampleImages/Passport Front.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Passport Back.jpg";
import GuideModal from "../../UI/GuideModal/GuideModal";
export interface IViewSamplePassportPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SamplePassportPopup = (props: IViewSamplePassportPopup) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };

  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Uploading Passport"
      titleId="sample-passport-popup-title"
    >

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Passport in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="passport-row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Sample passport front" />
                  <div className="badge">1</div>
                </div>

                <span className="Aadhar-Label">FRONT</span>
              </span>
              <span className="Aadhar-Front-row mgl-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Sample passport back" />
                  <div className="badge">2</div>
                </div>

                <span className="Aadhar-Label">BACK</span>
              </span>
            </span>
          </span>
        </div>
    </GuideModal>
  );
};
export default SamplePassportPopup;
